module.exports = __webpack_public_path__ + "img/posh.2246cdaa.svg";